import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "textarea", "submitButton", "messages", "messageTotal"]

  connect() {
    this.initializeFormComponents(this.element)
  }

  submit(event) {
    event.preventDefault()
    event.stopPropagation()

    this.clearErrors()

    const form = this.formTarget
    const textarea = this.textareaTarget

    if (!textarea.value.trim()) {
      this.showError("Please enter a message before sending.")
      return
    }

    if (form.querySelector(".progress .bar")) {
      this.showError("Please wait until file upload is complete, then try again.")
      return
    }

    this.addTempAttachmentIds(form)

    this.setLoadingState(true)

    const formData = new FormData(form)

    fetch(form.action + '.json', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      if (data.success) {
        if (this.hasMessagesTarget) {
          this.messagesTarget.insertAdjacentHTML('beforeend', data.message_html)
          const newMessages = this.messagesTarget.querySelectorAll('.note')
          if (newMessages.length > 0) {
            const lastMessage = newMessages[newMessages.length - 1]
            lastMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
          }
        }

        const formContainer = document.getElementById(`message-form-${data.provider_uuid}`)
        if (formContainer) {
          formContainer.outerHTML = data.form_reset_html

          // Reinitialize form components for the new form
          const newFormContainer = document.getElementById(`message-form-${data.provider_uuid}`)
          if (newFormContainer) {
            this.initializeFormComponents(newFormContainer)
          }
        }

        this.updateMessageCount(data.message_count, data.message_text, data.provider_uuid)
      } else {
        this.showError(data.error || "Timeline entry could not be saved. Please review your message and try again.")
      }
    })
    .catch(error => {
      this.showError("An error occurred while sending your message. Please try again.")
    })
    .finally(() => {
      this.setLoadingState(false)
    })
  }

  updateMessageCount(count, text, providerUuid) {
    if (this.hasMessageTotalTarget) {
      this.messageTotalTarget.textContent = `${count} ${text}`
    }

    const uuid = providerUuid || this.quotedWareIdValue
    const supplierItem = document.querySelector(`[data-uuid="${uuid}"]`)
    if (supplierItem) {
      const messageTotalElement = supplierItem.querySelector('.message-total')
      if (messageTotalElement) {
        messageTotalElement.textContent = `${count} ${text}`
      }
    }
  }

  setLoadingState(loading) {
    const submitButton = this.submitButtonTarget

    if (loading) {
      submitButton.disabled = true
      submitButton.dataset.originalText = submitButton.textContent
      submitButton.textContent = 'Sending...'
    } else {
      submitButton.disabled = false
      submitButton.textContent = submitButton.dataset.originalText || 'Send'
    }
  }

  showError(message) {
    this.clearErrors()

    const errorDiv = document.createElement('div')
    errorDiv.className = 'alert alert-danger error-message'
    errorDiv.textContent = message

    this.formTarget.insertAdjacentElement('afterbegin', errorDiv)

    // Auto-hide after 5 seconds
    setTimeout(() => {
      errorDiv.remove()
    }, 5000)
  }

  clearErrors() {
    this.element.closest('.modal').querySelectorAll('.alert').forEach(msg => msg.remove())
  }

  closeModal() {
    this.element.closest('.modal').modal('hide')
  }

  addTempAttachmentIds(form) {
    // Vanilla JS version of TempAttachments logic
    const uploadedFiles = form.querySelectorAll('[data-upload-id]')
    uploadedFiles.forEach(row => {
      const uploadId = row.getAttribute('data-upload-id')
      if (uploadId) {
        const hiddenInput = document.createElement('input')
        hiddenInput.type = 'hidden'
        hiddenInput.name = 'pg_note[temp_attachment_ids][]'
        hiddenInput.value = uploadId
        form.appendChild(hiddenInput)
      }
    })
  }

  initializeFormComponents(container) {
    const form = container.querySelector('form')
    if (form && window.$) {
      const $form = window.$(form)

      if (window.Messenger && window.Messenger.init) {
        window.Messenger.init()
      }

      if (window.initExpandableElements) {
        window.initExpandableElements()
      }

      if (window.TempAttachments && window.TempAttachments.setupForm) {
        window.TempAttachments.setupForm($form, 'pg_note')
      }
    }
  }
}
